import { BaseRestDataProvider } from './BaseRestDataProvider';
import { LedgerEntry } from '../models/LedgerEntry';

export class LedgerEntryRestDataProvider extends BaseRestDataProvider {
  constructor() {
    super('/v1/ledger-entries');
  }

  getAll(): Promise<LedgerEntry[]> {
    return this.get<LedgerEntry[]>(``);
  }

  getByLedgerId(ledgerId: string): Promise<LedgerEntry[]> {
    return this.get<LedgerEntry[]>(`?ledgerId=${ledgerId}`);
  }

  getById(id: string): Promise<LedgerEntry> {
    return this.get<LedgerEntry>(`/${id}`);
  }

  add(entry: LedgerEntry): Promise<LedgerEntry> {
    return this.post<LedgerEntry>(``, entry);
  }

  update(id: string, entry: LedgerEntry): Promise<void> {
    return this.put<void>(`/${id}`, entry);
  }

  delete(id: string): Promise<void> {
    return super.delete(`/${id}`);
  }
}

export type { LedgerEntry };
